export function formatNumber(n, decimals = 0) {
  if (n == null) return '—'
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(n)
}

export function formatPercent(n, decimals = 1) {
  if (n == null) return '—'
  return `${n.toFixed(decimals)}%`
}

export function formatDOS(dos) {
  if (dos == null) return '—'
  if (dos === Infinity || dos > 999) return '999+'
  if (dos < 0) return 'NEG'
  return dos.toFixed(1)
}

export function formatDate(iso) {
  if (!iso) return '—'
  return new Date(iso).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

export function formatRelativeTime(iso) {
  if (!iso) return '—'
  const ms = Date.now() - new Date(iso).getTime()
  const hours = ms / (1000 * 60 * 60)
  if (hours < 1) return 'just now'
  if (hours < 24) return `${Math.floor(hours)}h ago`
  const days = Math.floor(hours / 24)
  if (days === 1) return '1 day ago'
  return `${days} days ago`
}

export function getGreeting() {
  const hour = new Date().getHours()
  if (hour < 12) return 'Good morning'
  if (hour < 17) return 'Good afternoon'
  return 'Good evening'
}

export function getFreshnessState(isoTimestamp, freshHours = 24, agingHours = 72) {
  if (!isoTimestamp) return 'stale'
  const hours = (Date.now() - new Date(isoTimestamp).getTime()) / (1000 * 60 * 60)
  if (hours < freshHours) return 'fresh'
  if (hours < agingHours) return 'aging'
  return 'stale'
}
